import WorkHistoryRow from './WorkHistoryRow';

export default WorkHistoryRow;
